import { useResultsContext } from "../context/results-context";
import { SectionSummary } from "./section/section-summary";
import { SectionMutantDescription } from "./section/section-mutant-description";
import { SectionKnownMutants } from "./section/section-known-mutants";
import { SectionCatalyticResidues } from "./section/section-catalytic-residues";
import { SectionConservation } from "./section/section-conservation";
import { SectionStructure3d } from "./section/section-structure-3d";
import { SectionInhibitorList } from "./section/section-inhibitor-list";
import { SectionInhibitorChart } from "./section/section-inhibitor-chart";
import { SectionAdditionalInformation } from "./section/section-additional-information";
import { Element } from "react-scroll";
import * as React from "react";
import scrollToSection from "./scrollToSection";
import { ReactNode, useCallback } from "react";

function ReportSections() {

  const {
    availableSections: sections,
    selectedSections,
  } = useResultsContext();

  const scrollToSelectedSection = useCallback((sectionId: string) => {
    const section = sections.find(section => section.id === sectionId);
    if (section !== undefined && selectedSections[sectionId]) {
      scrollToSection(sectionId);
    }
  }, [sections, selectedSections, scrollToSection]);

  const scrollToInhibitorList = useCallback(() => scrollToSelectedSection('inhibitor_list'), [scrollToSelectedSection]);
  const scrollToInhibitorChart = useCallback(() => scrollToSelectedSection('inhibitor_chart'), [scrollToSelectedSection]);

  return <>
    {sections.map(section => {
      let toRender: ReactNode;
      switch (section.id) {
        case 'summary':
          toRender = <SectionSummary section={section} scrollToInhibitorList={scrollToInhibitorList}/>
          break;
        case 'mutant_description':
          toRender = <SectionMutantDescription section={section}/>
          break;
        case 'known_mutants':
          toRender = <SectionKnownMutants section={section}/>
          break;
        case 'catalytic_residues':
          toRender = <SectionCatalyticResidues section={section}/>
          break;
        case 'conservation':
          toRender = <SectionConservation section={section}/>
          break;
        case 'structure_3d':
          toRender = <SectionStructure3d section={section}/>
          break;
        case 'inhibitor_list':
          toRender = <SectionInhibitorList section={section} scrollToInhibitorChart={scrollToInhibitorChart}/>
          break;
        case 'inhibitor_chart':
          toRender = <SectionInhibitorChart section={section}/>
          break;
        case 'additional_information':
          toRender = <SectionAdditionalInformation section={section}/>
          break;
        default:
          console.error('Render function for section', section.id, 'not found');
          return null;
      }
      return <Element key={section.id} name={section.id}>{toRender}</Element>;
    })}
  </>

}

export default ReportSections;